import React from 'react'

import './Wishlist.scss'

const Wishlist = ({
  className = '',
  width = '1em',
  height = '1em',
  filled = false,
  fillColor = '#D42114',
  loading = false,
  ...props
}) => (
  <svg className={`ac-icon ac-icon__wishlist${loading && ' ac-icon__wishlist--loading'} ${className}`} width={width} height={height} {...props} viewBox={loading ? '-1 -1 26 26' : '0 0 24 24'} version="1.1" xmlns="http://www.w3.org/2000/svg">
    { (loading || filled) && <path fill={loading ? 'none' : fillColor} stroke={fillColor} strokeWidth={loading ? 2 : 0} d="M12.7,3.9c2.6-2.5,6.8-2.6,9.4,0c2.6,2.5,2.6,6.6,0.1,9.1c0,0-0.1,0.1-0.1,0.1l-9.7,8.7c-0.2,0.2-0.5,0.2-0.7,0l-9.7-8.7C-0.6,10.6-0.7,6.6,1.9,4c0,0,0.1-0.1,0.1-0.1c2.6-2.5,6.8-2.5,9.4,0L12,4.6L12.7,3.9L12.7,3.9z"/> }
    { !loading && <path d="M12 7.422l-1.412-1.405-.68-.677C8.096 3.555 5.15 3.553 3.341 5.336c-1.79 1.765-1.79 4.625-.066 6.327L12 19.483l8.653-7.755a4.47 4.47 0 0 0 .003-6.392c-1.805-1.78-4.752-1.78-6.562 0L12 7.422zm.687-3.507c2.588-2.55 6.789-2.551 9.374-.003a6.47 6.47 0 0 1-.004 9.24l-9.723 8.719a.5.5 0 0 1-.668 0l-9.725-8.719a6.472 6.472 0 0 1-.003-9.24c2.588-2.55 6.785-2.549 9.373.003L12 4.6l.688-.685z"/> }
  </svg>
)

export default Wishlist
